import { render, staticRenderFns } from "./_modal.vue?vue&type=template&id=596f16f1&scoped=true&lang=pug&"
import script from "./_modal.vue?vue&type=script&lang=js&"
export * from "./_modal.vue?vue&type=script&lang=js&"
import style0 from "./_modal.vue?vue&type=style&index=0&id=596f16f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596f16f1",
  null
  
)

export default component.exports